// Core-course groups (readonly arrays so consumers can't mutate accidentally)
const core1f: readonly string[] = [
  "CIV100",
  "MAT186",
  "MAT188",
  "APS111",
  "APS110",
  "APS100",
];
const core1s: readonly string[] = [
  "MIE100",
  "MAT187",
  "ECE110",
  "APS112",
  "APS105",
  "ECE101",
  "ECE191",
];
const core2f: readonly string[] = [
  "MAT291",
  "MAT290",
  "ECE241",
  "ECE244",
  "ECE201",
  "ECE231",
];
const core2s: readonly string[] = [
  "ECE221",
  "ECE216",
  "ECE243",
  "ECE297",
  "ECE295",
  "ECE212",
];

export { core1f, core1s, core2f, core2s };

/** Normalize input course code: trim and uppercase. Handles undefined/null safely. */
const normalizeCourseCode = (courseCode: string | undefined | null): string => {
  return (courseCode || "").toString().trim().toUpperCase();
};

/**
 * Return a compact semester code for a core course (e.g. "1F", "1S", "2F", "2S").
 * Returns "(??)" if the course is not in the core lists.
 */
export const CoreCourseToSemesterString = (courseCode: string): string => {
  const code = normalizeCourseCode(courseCode);
  if (core1f.includes(code)) return "1F";
  else if (core1s.includes(code)) return "1S";
  else if (core2f.includes(code)) return "2F";
  else if (core2s.includes(code)) return "2S";
  else return "(??)";
};

/**
 * Return a human-friendly semester string for a core course (e.g. "Year 1 Fall").
 * Returns "(??)" if the course is not in the core lists.
 */
export const CoreCourseToFullSemesterString = (courseCode: string): string => {
  const code = normalizeCourseCode(courseCode);
  if (core1f.includes(code)) return "Year 1 Fall";
  else if (core1s.includes(code)) return "Year 1 Spring";
  else if (core2f.includes(code)) return "Year 2 Fall";
  else if (core2s.includes(code)) return "Year 2 Spring";
  else return "(??)";
};

/**
 * Internal helper: returns an index for ordering core courses.
 * 0 = Year1 Fall, 1 = Year1 Spring, 2 = Year2 Fall, 3 = Year2 Spring, -1 = unknown
 */
const findCoreIndex = (courseCode: string): number => {
  const code = normalizeCourseCode(courseCode);
  if (core1f.includes(code)) return 0;
  if (core1s.includes(code)) return 1;
  if (core2f.includes(code)) return 2;
  if (core2s.includes(code)) return 3;
  return -1;
};

/**
 * Comparator suitable for Array.prototype.sort: unknown courses are treated as after known core courses.
 * Returns negative if A < B, positive if A > B, zero if equal position.
 */
export const CoreCourseComparator = (
  CourseCodeA: string,
  CourseCodeB: string
): number => {
  const A = findCoreIndex(CourseCodeA);
  const B = findCoreIndex(CourseCodeB);

  const aVal = A === -1 ? 99 : A;
  const bVal = B === -1 ? 99 : B;

  return aVal - bVal;
};
